import http from "@/http-common";

class EvaluationDailyStatisticsService {
  getDaily(date, gradeId, classId, mode) {
    return http.get("statistics/evaluation/daily", {
      params: { date, mode, gradeId: gradeId || undefined, classId: classId || undefined }
    });
  }
}

export default new EvaluationDailyStatisticsService();
